import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { environment } from 'src/environments/environment';
import { DemandasMonitoramento } from '../../models/demandas-monitoramento.model';
import { DemandasMonitoramentoService } from '../../services/demandas-monitoramento.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';

@Component({
  selector: 'app-detalhe-demandas-monitoramento-list',
  templateUrl: './detalhe-demandas-monitoramento-list.component.html',
  styleUrls: ['./detalhe-demandas-monitoramento-list.component.scss']
})
export class DetalheDemandasMonitoramentoListComponent extends BaseListComponent<DemandasMonitoramento> implements OnInit, OnDestroy {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  canDemand: boolean = false;
  canceladas: boolean;
  novaUrl: String;
  demandas: DemandasMonitoramento[];

  constructor(
    private myService: DemandasMonitoramentoService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super();
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;

      this.novaUrl = environment.serverUrl + '/demandas/demanda/adicionar?project_full_id=' + this.idProjeto;
      this.canceladas = false;
      this.initLoadDataTable();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.getListAll(this.idProjeto).subscribe((res) => {
        this.demandas = res;
        this.canDemand = res[0]?.canDemand;
        this.loaded();
      })
    );
  }

  view(id: number) {
    return ['/projetos', 'projeto', this.idProjeto, 'demandas', id, 'mensagens'];
  }

  mostrarCanceladas() {
    this.canceladas = !this.canceladas;
  }
}
